// extracted by mini-css-extract-plugin
export default {"flatlist":"flatlist_ba237df9fc67cfbb132c","container":"container_fef61f92462be37b96a7","popuplist":"popuplist_ede7ee5de64f24691abe"};